export default [
  {
    title: 'How people will move?',
    text: 'Read the story about the territory of 2026 Olympic Games with its main transportation hubs and connections. ' +
        'We present here our expectations about visitors coming by planes, cars and public transport. ' +
        'We start from expected flow of tourists that would reach Milan or Cortina by airplane. ' +
        'At first, the forecast has been split among all the' +
        ' airports of the region. Then we considered land transportation including public services and private cars.',
    bearing: 27,
    center: [12.138428, 46.537534],
    zoom: 16.5,
    pitch: 20,
  },
  {
    title: 'Milano Malpensa - 24%',
    text: 'Milano Malpensa is supposed to be the main airport of the Games. Located 49 kilometres (30 mi) northwest from the center of Milan, next to the Ticino river (dividing Lombardy and Piedmont), it is the main air connection node of Northern Italy. Most of visitors from abroad, especially from other continents, are expected to arrive here. ',
    bearing: 27,
    center: [8.7255307, 45.6300625],
    zoom: 10.5,
    pitch: 20,
  },
  {
    title: 'Milano Linate - 19%',
    text:
    'Milano Linate is a city airport of Milan, the third international airport of the city (after Malpensa and Bergamo. Its position is perfect for visitors coming from other part of Italy as well as neighboring countries.',
    center: [9.2763079, 45.4521756],
    bearing: 0,
    zoom: 12,
    speed: 0.7,
    pitch: 20,
  },
  {
    title: 'Bergamo - 17%',
    text: 'Branded as Milan Bergamo Airport, is the third busiest international airport in Italy. It is located in the municipal territory of Orio al Serio, 3.7 km (2.3 mi) southeast of Bergamo. The airport is 45 km (28 mi) north-east of Milan, where it operates alongside Malpensa and Linate. We expect to see a big number of visitors coming here. One of the reasons is a number of low-cost operators connected to this airport.',
    bearing: 90,
    center: [9.7036313, 45.6695707],
    zoom: 10,
    pitch: 40,
  },
  {
    title: 'Venice Marco Polo - 15%',
    text: 'Due to the importance of Venice as a leisure destination, it features flights from many European metropolitan areas as well as some partly seasonal long-haul routes to the United States, Canada, South Korea and the Middle East. It is the closest big international airport to Cortina itself. We expect here a big number of visitors, heading directly to Alpi Dolomiti and Cortina Valley after arriving here.',
    bearing: 90,
    center: [12.3597708, 45.5050611 ],
    zoom: 11.2,
  },
  {
    title: 'Treviso - 14%',
    text: 'Secondary airport of Venice. It is well used by low-cost airlines. We expect here some customers coming from other regions of Italy.',
    bearing: 90,
    center: [12.191999232, 45.650497398],
    zoom: 12.5,
    pitch: 40,
  },
  {
    title: 'Verona - 13%',
    text: 'Verona Villafranca Airport is situated next to the junction of A4 Milan-Venice and A22 Modena-Brenner motorways. It serves a population of more than 4 million inhabitants in the provinces of Verona, Brescia, Mantua (Mantova) and Trentino-Alto Adige/Südtirol.',
    bearing: 0,
    center: [10.8901406, 45.4000011],
    zoom: 11.5,
    pitch: 20,
  },

  {
    title: 'Brenner Pass',
    text: 'Considering visitors coming to Cortina region and Milan from the North countries such as Germany or Austria, ' +
        'we can definitely say that Brenner pass is the main entering point to Northern Italy. Being not only the' +
        ' beginning of Autostrada A22, it is also crucially important connection of the European railway system.' +
        ' We expect most of the visitors traveling by car or by train from nearby countries to enter the region ' +
        'of Olympic Games here.',
    bearing: 0,
    center: [11.505508, 47.004888],
    zoom: 11.5,
    pitch: 40,

  },
  {
    title: 'Dobbiaco',
    text: "The town of Dobbiaco (also know as Toblach) is the closest big town on the North from Cortina. It is well connected with the rail station and Public Airport. The location of Toblach allows it to be considered as the main transport node for the region for customers approaching from the North. Also, the territory allows to place here several intercepting parking areas in order to reduce the amount of cars parked near Cortina d'Ampezzo. All customers willing to leave their vehicle here will be provided with a free public transport to reach Cortina.",
    bearing: 180,
    center: [12.225514, 46.7247842],
    zoom: 11.5,
    pitch: 20,
   },
  {
    title: 'Dobbiaco Railway Station',
    text: 'The station is a modern transportation hub that allows a comfortable interchange to buses' +
        ' coming directly to Cortina. The station is operated by SAD is able to handle reasonable amount of visitors changing from train coming from Bolzano to the bus ' +
        'that will transfer them directly to Cortina in less than one hour.',
    bearing: 180,
    center: [12.225514, 46.7247842],
    zoom: 18,
    pitch: 50,
  },
  {
    title: 'Dobbiaco Aiport',
    text: 'Having no hard pavement on the runway accept passenger flights, it can be used for emergency services' +
        ' or technical purposes.',
    bearing: 180,
    center: [12.227507, 46.727366],
    zoom: 15,
    pitch: 40,
  }, //  46°26'39"N   12°22'57"
    
  {
    title: 'Calalzo di Cadore',
    text: "Situated south-east from Cortina d'Ampezzo, it is an entry point to the valley for visitors coming from the main airports and also from the rest of Italy. We expect to have a shuttle bus service to start here for transporting visitors directly to` Cortina d'Ampezzo itself.",
    bearing:  0,
    center: [12.384334, 46.445463],
    zoom: 13,
    pitch: 20,
  },

  {
    title: 'Calalzo Railway Station',
    text: 'The station is a terminal point for Calalzo–Padua Railway - one of the most important lines in the region of Veneto. It is owned by Ferrovie dello Stato, operated by Trenitalia and is able to operate most of passenger trains.',
    bearing:  180,
    center: [12.388534, 46.444020],
    zoom: 16.5,
    pitch: 35,
  },
  {
    title: 'Calalzo Bus Station',
    text: 'Located near the railway station, this depot is used by DolomitiBus - the main bus transport service provider of the region. The depot is able to host less than 30 buses at the moment. This amount is enough. However, during the Games, the number of buses operating on the line Calalzo - Cortina will be significantly increased. We consider this fact as a problem to solve and argue that another area can be added nearby to host needed amount of buses during the Games.',
    bearing:  350,
    center: [12.387867, 46.444659],
    zoom: 19,
    pitch: 45,
  },
    
  {
    title: "Cortina d'Ampezzo",
    text:'According to our forecasts, the maximum number of spectators per day is expected to be around 41,800 people, with maximum of 26,000 coming just in one morning. This raises problems of transportation and parking. Although, we expect a good level of public transport connection, a big number of visitors will use their own vehicles to reach the place. The public transport part is described in another part of the website. Here we are considering the ability of the area to place a reasonable amount of parking slots.',
    bearing:  0,
    center: [12.138428, 46.537534],
    zoom: 13,
    pitch: 20,
  },
  {
    title: 'Fiames ',
    text:'According to our estimation, ~750 car parking places are available here. The cars reached Cortina from North can be parked here ',
    bearing:  90,
    center: [12.118494, 46.572822],
    zoom: 17,
    pitch: 40,
  },
  {
    title: 'Pocol ',
    text:'~120 places are available here. This is the west side.',
    bearing:  275,
    center: [12.113086 , 46.524055],
    zoom: 16,
    pitch: 40,
  },
  {
    title: 'Acquabona ',
    text:'Here ~750 places are available for those, coming from the South.',
    bearing:  0,
    center: [12.157677, 46.506539],
    zoom: 16,
    pitch: 40,
  },
]
